import {
  ActionIcon,
  Box,
  Button,
  Group,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  Textarea,
  Grid,
  rem,
  Checkbox,
  Badge,
  Divider,
  Paper,
  Table,
  ScrollArea,
  // Pill
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import {
  IconChevronDown,
  IconPlus,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { decrypt, showError, states } from "../../utils";
import useStyles from "./style";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { CloseIconSvg } from "../Svgs/CloseIconSvg";
import { FaChevronRight } from "react-icons/fa6";
import BillingSearchBar from "../Document/BillingSearchBar";
import { useSelector } from "react-redux";
import { getdiagnosiscode } from "../../services/servicecode";
import swal from "sweetalert";
import { getBillingProvider } from "../../services/billingprovider";
import { levelOfNeedOptions } from "../../pages/Home/Task/AddTask";

export const careLevelOptions = [
  "Memory Care",
  "Personal Care",
  "Independent Living",
  "Skilled Nursing",
  "Supervisory Care",
  "Directed Care",
  "Behavioral Health Care",
  "Custodial Care",
  "Medical Care",
  "Directed Care",
  "Hospice Care",
  "Transitional Care",
  "Supervised living",
  "Post Home Companion Care",
  "Residential support services",
  "Texas Home Living",
  "Assisted Care Facility",
];

const HealthForm = forwardRef(
  (
    {
      title,
      edit,
      functions,
      view,
      setState,
      setActive,
      state,
      active,
      handleFormSubmit,
      options,
      saveHandle,
      selectedTab,
      facility,
      populateFacility,
      // classes,
    },
    ref
  ) => {
    // console.log("state inside health form", state);

    const { classes } = useStyles();
    const icon = <DropDownArrowSvg style={{ width: rem(1), height: rem(1) }} />;
    const [knownIllness, setKnownIllness] = useState([]);
    const [knownIllnessField, setKnownIllnessField] = useState("");
    const [diagnosis, setDiagnosis] = useState([]);
    const [services, setServices] = useState(null);
    const [knownAllergies, setKnownAllergies] = useState([]);
    const [allergiesField, setAllergiesField] = useState("");
    const [noAllergies, setNoAllergies] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [dietaries, setDietaries] = useState([]);
    const [dietariesField, setDietariesField] = useState("");
    const [servicesinfo, setServicesinfo] = useState([]);
    const [noDietaryRestrictions, setNoDietaryRestrictions] = useState(false);
    const [diagnosisField, setDiagnosisField] = useState({
      code: "",
      name: "",
    });

    const alldiagnosiscode = useSelector(
      (state) => state.servicecode.alldiagnosisCode
    );
    const [diagnosisSearchValue, setDiagnosisSearchValue] = useState("");
    const { allbillingprovider } = useSelector(
      (state) => state.billingprovider
    );

    useEffect(() => {
      getBillingProvider();
    }, []);

    useEffect(() => {
      if (active === 0 && state?.form1) {
        form.setValues({
          ...state?.form1,
          levelofneed: state?.form1?.levelofneed?.replace(/–/g, '-') || "",
        });
        setDietaries(state?.form1?.dietaries || []);
        setKnownIllness(
          state.form1?.knownIllness?.length > 0 &&
            state.form1?.knownIllness?.[0]?.illness
            ? state.form1?.knownIllness?.map((item) => item.illness)
            : state.form1?.knownIllness || []
        );
        setKnownAllergies(state?.form1?.knownAllergies || []);
        setDiagnosis(state?.form1?.diagnosis || []);
        setServicesinfo(state?.form1?.services || []);
      }
    }, [active, state]);

    const handleServiceChange = (value) => {
      setServices(value);
    };

    const handleServiceFieldChange = (field, value) => {
      setServices((prevServices) => {
        const updatedServices = {
          ...prevServices,
          [field]: value,
        };

        if (
          updatedServices.servicechargeNumber &&
          updatedServices.servicechargeAmount
        ) {
          updatedServices.totalCharge =
            updatedServices.servicechargeNumber *
            updatedServices.servicechargeAmount;
        }

        return updatedServices;
      });
    };

    const addService = () => {
      if (
        !services ||
        !services.servicechargeAmount ||
        !services.servicechargeNumber ||
        !services.servicechargetype ||
        !services.servicenumber ||
        !services.servicetitle ||
        !services.totalCharge
      ) {
        showError("Missing or empty fields", 400);
        return;
      }
      if (services) {
        setServicesinfo((prevServicesinfo) => [...prevServicesinfo, services]);
        setServices(null);
      }
    };
    const removeServices = async (index) => {
      const willDelete = await swal({
        title: `Are you sure want to delete this service?`,
        text: "",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel", "Delete"],
      });
      if (willDelete) {
        let temp = servicesinfo?.filter((_, i) => i !== index);
        setServicesinfo(temp);
      }
    };

    // console.log('state?.form1?.facility',state?.form1?.facility);

    // console.log('diagnosis',diagnosis);

    const DNRCodeOptions = ["Level 1", "Level 2", "Level 3", "Level 4"];
    // const levelOfNeedOptions = [
    //   "LON 1 - Intermittent",
    //   "LON 5 - Limited",
    //   "LON 8 - Extensive",
    //   "LON 6 - Pervasive",
    //   "LON 9 - Pervasive+",
    // ];
    const form = useForm({
      initialValues: {
        levelOfCare: "",
        dnrCode: "",
        knownIllness,
        facility: null,
        summary: "",
        knownAllergies,
        dietaries,
        // noDietaryRestrictions,
        // noAllergies,
        // contagious: "no",
        // patientWounds: "no",
        // isKnownIllness: "no",
      },
      // validate: {
      //   levelOfCare: (value) => (value.trim() ? null : "Level of Care is required"),
      //   dnrCode: (value) => (value.trim() ? null : "DNR Code is required"),
      //   knownIllness: (value) => (value.trim() ? null : "Known Illness is required"),
      //   facility: (value) => (value ? null : "Facility is required"),
      //   summary: (value) => (value.trim() ? null : "Summary is required"),
      //   knownAllergies: (value) => (value.trim() ? null : "Known Allergies is required"),
      //   dietaries: (value) => (value.trim() ? null : "Dietary Restrictions are required"),
      //  },
    });

    useImperativeHandle(ref, () => ({
      confirm: () => {
        // console.log("Called");
        let values = form.values;
        let valid = form?.validate();
        if (Object.keys(valid?.errors).length === 0) {
          let lengthToMask = (values?.socialSecurityNumber?.length || 4) - 4;
          let obj = {
            ...state,
            form1: {
              ...values,
              knownIllness,
              dietaries,
              lastFourDigits: `${"*".repeat(
                lengthToMask
              )}${values?.socialSecurityNumber?.slice(-4)}`,
            },
          };

          setState(obj);
          setActive(1);
        }
      },
    }));

    const isMobileScreen = useMediaQuery("(max-width: 600px)");

    const onSave = () => {
      const values = form.getTransformedValues();

      let tempForm1 = {
        ...state.form1,
        ...{
          knownIllness,
          knownAllergies,
          dietaries,
          services: servicesinfo,
          diagnosis,
          levelofcare: values.levelofcare,
          levelofneed: values.levelofneed,
          dnrCode: values.dnrCode,
          summary: values.summary,
          dietaryRestrictions: "",
          isForm1: true,
          socialSecurityNumber: decrypt(
            state?.form1?.socialSecurityNumber,
            false
          ),
        },
      };

      let obj = {
        ...state,
        form1: tempForm1,
      };

      let valid = form?.validate();
      handleFormSubmit("healthInfo", "careSupportInfo");
      if (Object.keys(valid?.errors).length === 0) {
        setState(obj);
        setActive(1);
        saveHandle(tempForm1, null, null);
      }
    };

    const onNext = (values, formName) => {
      let obj = {
        ...state,
        form1: {
          // ...(formName === "personalInfo" && { ...values }),
          ...state.form1,
          ...(formName === "healthInfo" && {
            // ...values,
            knownIllness,
            knownAllergies,
            dietaries,
            levelofcare: values.levelofcare,
            dnrCode: values.dnrCode,
            levelofneed: values.levelofneed,
            summary: values.summary,
            dietaryRestrictions: "",
            isForm1: true,
            services: servicesinfo,
            diagnosis,
          }),
        },
      };

      let valid = form?.validate();
      handleFormSubmit("healthInfo", "careSupportInfo");
      if (Object.keys(valid?.errors).length === 0) {
        setState(obj);
        setActive(1);
      }
    };

    // const handleChangeDiagnosis = (index, value) => {
    //   let temp = [...knownIllness];
    //   setKnownIllness([...temp, knownIllnessField]);
    //   setKnownIllnessField("");
    // };
    const handleChangeDiagnosis = () => {
      if (!diagnosisField.code || !diagnosisField.name) {
        showError("Missing or empty fields", 400);
        return;
      }

      const newDiagnosis = {
        code: diagnosisField.code,
        name: diagnosisField.name,
      };

      setDiagnosis((prevDiagnosis) => [...prevDiagnosis, newDiagnosis]);

      // Clear the diagnosisField after adding
      setDiagnosisField({
        code: "",
        name: "",
      });
      setDiagnosisSearchValue('')
    };

    const handleChangeAllergies = (index, value) => {
      let temp = [...knownAllergies];
      setKnownAllergies([...temp, allergiesField]);
      setAllergiesField("");
    };

    const handleChangeDietary = (index, value) => {
      let temp = [...dietaries];
      setDietaries([...temp, dietariesField]);
      setDietariesField("");
    };

    const addEmptyAllergy = () => {
      let temp = [...knownIllness];
      temp.push([]);
      setKnownIllness(temp);
    };
    // const removeDiagnosis = (index) => {
    //   let temp = knownIllness?.filter((_, i) => i !== index);
    //   setKnownIllness(temp);
    // };

    const removeDiagnosis = (index) => {
      let temp = diagnosis?.filter((_, i) => i !== index);
      setDiagnosis(temp);
    };

    const removeAllergy = (index) => {
      let temp = knownAllergies?.filter((v, i) => i !== index);
      setKnownAllergies(temp);
    };
    const removeDietary = (index) => {
      let temp = dietaries?.filter((v, i) => i !== index);
      setDietaries(temp);
    };
    const handleNoAllergiesChange = (v) => {
      setNoAllergies(v?.target?.checked);
      if (v?.target?.checked === true) {
        setKnownAllergies([]);
      }
    };

    const handleNoDietaryRestrictionsChange = (v) => {
      setNoDietaryRestrictions(v?.target?.checked);
      if (v?.target?.checked === true) {
        setDietaries([]);
      }
    };

    return (
      <form onSubmit={form?.onSubmit((values) => onNext(values, "healthInfo"))}>
        <Box className={classes.healthFormContainer}>
          <Box>
            <Text fz={20} weight={500}>
              {title}
            </Text>
            <Grid className={classes.healthDropdowns}>
              <Grid.Col span={6}>
                <Select
                  id="level-of-care"
                  searchable
                  label="Level of Care"
                  data={careLevelOptions}
                  size="md"
                  placeholder="Select Level of Care"
                  {...form.getInputProps("levelofcare")}
                  disabled={view}
                  className={classes.select}
                  variant="filled"
                  required
                  rightSection={icon}
                />
              </Grid.Col>
              <Grid.Col span={6}>
                <Select
                  id="d_n_r_code"
                  searchable
                  label="DNR Code"
                  data={DNRCodeOptions}
                  size="md"
                  placeholder="Select DNR Code"
                  {...form.getInputProps("dnrCode")}
                  disabled={view}
                  className={classes.select}
                  variant="filled"
                  required
                  rightSection={icon}
                />
              </Grid.Col>
            </Grid>
            <SimpleGrid cols={1} mt={20}>
              <Box>
                <Box className={classes.inputLabel}>
                  <Text ff={"Inter"} className={classes.myfont}>
                    Diagnosis
                  </Text>
                </Box>

                <BillingSearchBar
                  placeholder="Search diagnos name..."
                  data={(alldiagnosiscode &&
                  alldiagnosiscode.diagnosiscode &&
                  diagnosisSearchValue
                    ? alldiagnosiscode.diagnosiscode
                    : []
                  ).map((item) => ({
                    value: item,
                    label: item?.shortdescription,
                    key: item?.code,
                  }))}
                  onChange={(item) => {
                    typeof item === "string" && item && getdiagnosiscode(item);
                    setDiagnosisField({
                      code: item?.code,
                      name: item?.shortdescription,
                    });
                  }}
                  value={
                    typeof diagnosisSearchValue === "string"
                      ? diagnosisSearchValue
                      : diagnosisSearchValue?.shortdescription
                  }
                  setValue={setDiagnosisSearchValue}
                />

                <Box className={classes.healthdflex}>
                  <Box className={classes.healthwidthbox}>
                    <Text className={classes.myfont}>Diagnosis Name</Text>
                    <TextInput
                      name="code"
                      // disabled={true}
                      readOnly
                      size="sm"
                      value={diagnosisField?.name}
                    />
                  </Box>

                  <Box className={classes.healthwidthbox}>
                    <Text className={classes.myfont}>Diagnosis ID</Text>
                    <TextInput
                      name="code"
                      // disabled={true}
                      readOnly
                      size="sm"
                      value={diagnosisField?.code}
                    />
                  </Box>

                  {/* <ActionIcon
                        color="yellow"
                        variant="light"
                        mt={23}
                        size={20}
                        onClick={() => handleChangeDiagnosis()}
                      >
                        <IconPlus id="add-diagnoses" />
                      </ActionIcon> */}
                </Box>
              </Box>

              <Button
                type="button"
                c={"var(--app-on-primary)"}
                onClick={() => handleChangeDiagnosis()}
                variant="fixed"
                bg={"var(--app-primary)"}
                size="sm"
                w={"100%"}
              >
                + Add
              </Button>
              {diagnosis.length > 0 ? (
                <>
                  <Divider></Divider>

                  <Box style={{ marginTop: "19px" }}>
                    <Paper
                      sx={{
                        borderRadius: "8px !important",
                        border: "1px solid var(--app-border) !important",
                        padding: "26px 0px 14px 0px",
                      }}
                      withBorder
                    >
                      <ScrollArea
                        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
                        sx={{ minHeight: "50px" }}
                      >
                        <Table className={classes.table} striped>
                          <thead>
                            <tr>
                              <th className={classes.tableheader}>
                                Diagnosis Name
                              </th>
                              <th className={classes.tableheader}>
                                Diagnosis ID
                              </th>
                              <th className={classes.tableheader}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {diagnosis?.map((value, index) => (
                              <tr key={index}>
                                <td className={classes.tablepara}>
                                  {value.name}
                                </td>
                                <td className={classes.tablepara}>
                                  {value?.code}
                                </td>
                                <td className={classes.tablepara}>
                                  <Button
                                    onClick={() => removeDiagnosis(index)}
                                    id="health-next"
                                    radius="sm"
                                    size="sm"
                                    color="red"
                                    variant="light"
                                    styles={(theme) => ({
                                      root: {
                                        color: "var(--app-text)",
                                      },
                                    })}
                                  >
                                    Remove
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </ScrollArea>
                    </Paper>
                  </Box>
                </>
              ) : null}
            </SimpleGrid>
            <Grid>
              <Grid.Col mt={20}>
                <Box className={classes.textInputBox}>
                  <Text className="label">Diagnosis Summary</Text>
                  <Textarea
                    id="diagnosis-summary"
                    autosize={view}
                    minRows={4}
                    maxRows={10}
                    size="sm"
                    disabled={view}
                    placeholder="Entry Diagnosis Summary"
                    {...form.getInputProps("summary")}

                    // value={act?.supportActivity}
                    // onChange={(e) => {
                    //   handleactivityChange(
                    //     out?.id,
                    //     "supportActivity",
                    //     e?.target?.value,
                    //     act?.id
                    //   );
                    // }}
                  />
                </Box>
              </Grid.Col>
            </Grid>
            <Grid mt={10}>
              <Grid.Col span={6}>
                <Select
                  id="level-of-need"
                  searchable
                  label="Level of Need"
                  data={levelOfNeedOptions}
                  size="md"
                  placeholder="Select Level of Need"
                  {...form.getInputProps("levelofneed")}
                  disabled={view}
                  className={classes.select}
                  variant="filled"
                  required={false}
                  rightSection={icon}
                />
              </Grid.Col>
            </Grid>
            <SimpleGrid cols={1} mt={20}>
              <Group className={classes.diagnosis}>
                <Group>
                  <Box>
                    <Box className={classes.inputLabel}>
                      <Text ff={"Inter"} className={classes.myfont}>
                        Allergies
                      </Text>
                      <Checkbox
                        size="xs"
                        color="yellow"
                        disabled={view}
                        label="No Allergies"
                        // {...form.getInputProps("noAllergies")}
                        onChange={handleNoAllergiesChange}
                      />
                    </Box>
                    {!noAllergies && (
                      <TextInput
                        id="individual-allergy"
                        className={classes.allergiesDietaryInput}
                        size="md"
                        placeholder="Enter Allergies"
                        value={allergiesField}
                        onChange={(e) => setAllergiesField(e?.target?.value)}
                        // {...form.getInputProps("knownAllergies")}
                      />
                    )}
                  </Box>
                  {!noAllergies && (
                    <ActionIcon
                      color="yellow"
                      opacity={0.8}
                      variant="light"
                      mt={23}
                      size={20}
                      disabled={allergiesField === ""}
                      onClick={() => handleChangeAllergies()}
                    >
                      <IconPlus id="add-allergy" size={"md"} />
                    </ActionIcon>
                  )}
                </Group>
                {knownAllergies?.map((value, index) => (
                  <Group key={index}>
                    <Group className={classes.tags}>
                      <Badge
                        className={classes.allergiesTags}
                        color="#1DA7061A"
                        radius="xs"
                        size="lg"
                        value={value}
                      >
                        {value}
                      </Badge>
                      <CloseIconSvg
                        className={classes.close}
                        onClick={() => removeAllergy(index)}
                      />
                    </Group>
                  </Group>
                ))}
              </Group>

              <Group>
                <Group className={classes.diagnosis}>
                  <Group>
                    <Box>
                      <Box className={classes.inputLabel}>
                        <Text ff={"Inter"} className={classes.myfont}>
                          Dietary Restrictions
                        </Text>
                        <Checkbox
                          size="xs"
                          color="yellow"
                          disabled={view}
                          label="No Dietary"
                          // {...form.getInputProps("noDietaryRestrictions")}
                          onChange={handleNoDietaryRestrictionsChange}
                        />
                      </Box>
                      {!noDietaryRestrictions && (
                        <TextInput
                          id="individual-restriction"
                          className={classes.allergiesDietaryInput}
                          size="md"
                          placeholder="Entry Dietary Restrictions"
                          value={dietariesField}
                          onChange={(e) => setDietariesField(e?.target?.value)}
                          // disabled={value.isChecked}
                        />
                      )}
                    </Box>
                    {!noDietaryRestrictions && (
                      <ActionIcon
                        opacity={0.8}
                        color="yellow"
                        variant="light"
                        mt={23}
                        size={20}
                        disabled={dietariesField === ""}
                        // ref={addFieldRef}
                        onClick={() => handleChangeDietary()}
                      >
                        <IconPlus id="add-restriction" size={"md"} />
                      </ActionIcon>
                    )}
                  </Group>
                </Group>
                {dietaries?.map((value, index) => (
                  <Group key={index} className={classes.tags}>
                    <Badge
                      className={classes.dietariesTag}
                      color="#1DA7061A"
                      radius="xs"
                      size="lg"
                      value={value}
                    >
                      {value}
                    </Badge>
                    <CloseIconSvg
                      className={classes.close}
                      onClick={() => removeDietary(index)}
                    />
                  </Group>
                ))}
              </Group>

              {/* {services info} */}
              <Group>
                <>
                  <Box className={classes.inputLabel}>
                    <Text ff={"Inter"} className={classes.myfont}>
                      Services
                    </Text>
                  </Box>

                  <Box className={classes.healthsearchbox}>
                    <Select
                      icon={<IconSearch size={25} />}
                      sx={{
                        ".mantine-1qj7q0z": {
                          display: "none",
                        },
                      }}
                      placeholder="Search Service, Service Title"
                      data={
                        allbillingprovider &&
                        allbillingprovider?.billingprovider?.length > 0
                          ? allbillingprovider?.billingprovider
                              .filter((p) => {
                                const providerFacilityId = p.facilityId?.id;

                                const targetFacilityIds =
                                  facility?.length > 0
                                    ? facility
                                    : populateFacility?.map((f) => f.id) ?? [];
                                return targetFacilityIds.includes(
                                  providerFacilityId
                                );

                                // return facility?.includes(targetFacilityIds);
                              })
                              .flatMap((p) =>
                                (p.services || [])
                                  .filter(
                                    (item) =>
                                      !servicesinfo?.some(
                                        (s) =>
                                          s.servicetitle ===
                                            item.servicetitle &&
                                          s.servicenumber === item.servicenumber
                                      )
                                  )
                                  .map((item) => ({
                                    value: item,
                                    label: item?.servicetitle,
                                  }))
                              )
                          : []
                      }
                      onChange={(value) => {
                        handleServiceChange(value);
                      }}
                      nothingFound=" ⚠️ No Services Available: 
            To assign services to a client, you must first add them under the
            appropriate Facility. Please go to the Facility Menu and add at least
            one service in the Provider section to continue.
          "
                    />
                    {}
                  </Box>
                  <Box className={classes.healthdflex}>
                    <Box className={classes.healthfullw}>
                      <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                        Service Title
                      </Text>

                      <TextInput
                        value={services?.servicetitle || ""}
                        readOnly
                        size="sm"
                      />
                    </Box>

                    <Box className={classes.healthfullw}>
                      <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                        Service Code
                      </Text>
                      <TextInput
                        value={services?.servicenumber || ""}
                        onChange={(e) =>
                          handleServiceFieldChange(
                            "servicenumber",
                            e.target.value
                          )
                        }
                        readOnly
                        // value={serviceInfo.servicenumber}
                        // onChange={(e) => handleServiceChange("servicenumber", e.target.value)}

                        size="sm"
                      />
                    </Box>
                  </Box>

                  <Box className={classes.healthgap}>
                    <Box className={classes.healthcontainer}>
                      <Text ff="Inter" fz={14} fw={500} color="var(--app-text)">
                        Approved Unit
                      </Text>

                      <Box className={classes.healthboxWrapper}>
                        <TextInput
                          // value={services?.servicechargetype || ""}
                          className={classes.healthselectBilling}
                          rightSection={
                            <IconChevronDown color={"var(--app-text-muted)"} size={20} />
                          }
                          placeholder="Unit"
                          withAsterisk
                          variant="unstyled"
                          readOnly
                          size="sm"
                          value={services?.servicechargetype}
                        />

                        <TextInput
                          className={classes.healthinputField}
                          id="billing-name"
                          variant="unstyled"
                          type="number"
                          size="sm"
                          value={services?.servicechargeAmount || ""}
                          placeholder={"Amount"}
                          withAsterisk
                          onChange={(e) =>
                            handleServiceFieldChange(
                              "servicechargeAmount",
                              e.target.value
                            )
                          }
                        />
                      </Box>
                    </Box>
                    <Box className={classes.healthfullw}>
                      <Box className={classes.lookupflex}>
                        <Text ff={"Inter"} fz={14} fw={500} color="var(--app-text)">
                          Service Cost
                        </Text>
                        {/* <Text
                    style={{ cursor: "pointer" }}
                    // onClick={() => {
                    //   setOpenLookup(true);
                    // }}
                    ff={"Inter"}
                    fz={12}
                    fw={500}
                    color="#FD853A"
                  >
                    Lookup Rates
                  </Text> */}
                      </Box>

                      <TextInput
                        value={services?.servicechargeNumber}
                        onChange={(e) =>
                          handleServiceFieldChange(
                            "servicechargeNumber",
                            e.target.value
                          )
                        }
                        size="sm"
                      />
                    </Box>
                  </Box>

                  <Button
                    type="button"
                    c={"var(--app-on-primary)"}
                    onClick={addService}
                    variant="fixed"
                    bg={"var(--app-primary)"}
                    radius={8}
                    size="sm"
                    w={"100%"}
                  >
                    + Add Service
                  </Button>

                  {servicesinfo?.length > 0 ? (
                    <>
                      <Divider></Divider>

                      <Box style={{ marginTop: "19px" }}>
                        <Paper
                          sx={{
                            borderRadius: "8px !important",
                            border: "1px solid var(--app-border) !important",
                            paddingTop: "12px",
                          }}
                          withBorder
                        >
                          <Table className={classes.table} striped>
                            <thead>
                              <tr>
                                <th className={classes.tableheader}>
                                  Service Name
                                </th>
                                <th className={classes.tableheader}>Code</th>
                                <th className={classes.tableheader}>
                                  Value Type
                                </th>
                                <th className={classes.tableheader}>
                                  Approved Unit
                                </th>
                                <th className={classes.tableheader}>
                                  Payer Service Cost
                                </th>
                                <th className={classes.tableheader}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {servicesinfo?.map((existingService, index) => (
                                <tr key={index}>
                                  <td className={classes.tablepara}>
                                    {existingService?.servicetitle}
                                  </td>
                                  <td className={classes.tablepara}>
                                    {existingService?.servicenumber}
                                  </td>
                                  {/* <td className={classes.tablepara}>
                              {existingService?.servicechargetype || "N/A"}
                            </td> */}
                                  <td className={classes.tablepara}>
                                    <TextInput
                                      ta={"center"}
                                      className={classes.newinputbox}
                                      readOnly
                                      value={
                                        existingService?.servicechargetype ||
                                        "N/A"
                                      }
                                      variant="unstyled"
                                    />
                                  </td>

                                  {/* <td className={classes.tablepara}>
                              {existingService?.servicechargeNumber || "N/A"}
                            </td> */}

                                  <td className={classes.tablepara}>
                                    <TextInput
                                      ta={"center"}
                                      className={classes.newinputbox}
                                      readOnly
                                      value={
                                        existingService?.servicechargeAmount ||
                                        "N/A"
                                      }
                                      variant="unstyled"
                                    />
                                  </td>

                                  <td className={classes.tablepara}>
                                    <TextInput
                                      ta={"center"}
                                      className={classes.newinputbox}
                                      readOnly
                                      value={
                                        existingService.servicechargeNumber
                                      }
                                      variant="unstyled"
                                    />
                                  </td>

                                  <td>
                                    <Button
                                      onClick={() => removeServices(index)}
                                      id="health-next"
                                      radius="sm"
                                      size="sm"
                                      color="red"
                                      variant="light"
                                      styles={(theme) => ({
                                        root: {
                                          color: "var(--app-text)",
                                        },
                                      })}
                                    >
                                      Remove
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </Paper>
                      </Box>
                    </>
                  ) : null}
                </>
              </Group>

              {/* <Radio.Group
            name="isKnownIllness"
            label="Are there any known Illness?"
            {...form.getInputProps("isKnownIllness")}
            description="If 'Yes' Please tell Known Illness"
            onChange={(value) => {
              form?.setFieldValue("isKnownIllness", value);
              setIsKnownIllness(value === "yes");
            }}
          >
            <Group mt="xs">
              <Radio
                id="yes-radio-one"
                color="yellow"
                disabled={view}
                value="yes"
                label="Yes"
              />
              <Radio
                id="yes-radio-two"
                color="yellow"
                disabled={view}
                value="no"
                label="No"
              />
            </Group>
          </Radio.Group>
          {isknownIllness &&
            knownIllness?.map((value, index) => (
              // <Group grow>
              <Group align="center" grow key={index}>
                <span
                  style={{
                    marginTop: "20px",
                    flexGrow: 0.5,
                  }}
                >
                  {index + 1} .
                </span>

                <TextInput
                  className={classes.myfont}
                  label="Known Illness"
                  size="md"
                  icon={<img src="/assets/images/building.png" alt="address" />}
                  placeholder="Known Illness"
                  value={value?.illness}
                  onChange={(e) =>
                    handleChangeKnownIllness(index, e?.target?.value, "illness")
                  }
                  disabled={view}
                />

                <Radio.Group
                  // name={`contagious${index}`}
                  label="Is it Contagious?"
                  value={value?.contagious}
                  onChange={(value) => {
                    // console.log("index,value", index, value);
                    handleChangeKnownIllness(index, value, "contagious");
                  }}
                >
                  <Group mt="xs">
                    <Radio
                      color="yellow"
                      disabled={view}
                      value="yes"
                      label="Yes"
                    />
                    <Radio
                      color="yellow"
                      disabled={view}
                      value="no"
                      label="No"
                    />
                  </Group>
                </Radio.Group>
                <Group>
                  <ActionIcon
                    color="red"
                    variant="light"
                    // mt={23}
                    size={25}
                    opacity={0.9}
                    onClick={() => removeKnownIllness(index)}
                  >
                    <IconTrash size={"md"} />
                  </ActionIcon>
                  {index === knownIllness?.length - 1 && (
                    <ActionIcon
                      color="yellow"
                      variant="light"
                      // mt={23}
                      size={30}
                      onClick={addEmptyKnownIllness}
                    >
                      <IconPlus />
                    </ActionIcon>
                  )}
                </Group>
              </Group>
            ))}
          {isknownIllness && <Divider variant="dashed" />}

          <Radio.Group
            name="patientWounds"
            {...form.getInputProps("patientWounds")}
            label="Does the Client have any wounds?"
            onChange={(value) => {
              form.setFieldValue("patientWounds", value);
              setPatientWounds(value === "yes");
            }}
          >
            <Group mt="xs">
              <Radio color="yellow" disabled={view} value="yes" label="Yes" />
              <Radio color="yellow" disabled={view} value="no" label="No" />
            </Group>
          </Radio.Group>
          {patientWounds && (
            <Textarea
              autosize={view}
              className={classes.textArea}
              label="Wounds Information"
              size="md"
              icon={
                <img
                  src="/assets/images/linear-note.png"
                  alt="wounds"
                  className={classes.descriptionIcon}
                />
              }
              placeholder="Provide information about the client's wounds..."
              {...form.getInputProps("woundsInformation")}
              disabled={view}
            />
          )} */}
              {/* <div style={{ height: "180px", background: 'red' }} /> */}
            </SimpleGrid>
          </Box>
          <Box>
            {view ? (
              <div style={{ height: "30px" }} />
            ) : (
              <SimpleGrid cols={3} className={classes.btns}>
                <Button
                  variant="white"
                  color="yellow"
                  size="sm"
                  onClick={() => {
                    handleFormSubmit("", "personalInfo");
                  }}
                  styles={(theme) => ({
                    root: {
                      color: "var(--app-text)",
                    },
                    fontFamily: "inter",
                  })}
                >
                  Go Back
                </Button>
                <Box className={classes.centerBTN}>
                  <Button
                    color="yellow"
                    size="sm"
                    variant="outline"
                    radius="md"
                    styles={(theme) => ({
                      root: {
                        color: "var(--app-text)",
                        borderColor: "var(--app-primary)",
                      },
                    })}
                    onClick={() => {
                      handleFormSubmit("", "careSupportInfo");
                    }}
                  >
                    Add Later
                  </Button>
                  {edit && (
                    <Button
                      id="individual-next"
                      className="health-edit-save"
                      color="yellow"
                      radius="sm"
                      size="sm"
                      onClick={() => {
                        onSave();
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Box>
                <Button
                  id="health-next"
                  radius="sm"
                  size="sm"
                  color="yellow"
                  type="submit"
                  styles={(theme) => ({
                    root: {
                      color: "var(--app-on-primary)",
                    },
                  })}
                >
                  Next
                  <FaChevronRight />
                </Button>
              </SimpleGrid>
            )}
          </Box>
        </Box>
      </form>
    );
  }
);

export default HealthForm;
